import { CreateBasPracticeAdminDto } from 'src/entities/interfaces'
import { api } from 'src/services//api.service'

const create = (payload: CreateBasPracticeAdminDto) => {
  return api.post('/api/admin/baspractice', payload)
}

export default { create }
